import {AbstractControl} from '@angular/forms';
import * as moment from 'moment';

export function ValidateDate(control: AbstractControl) {
  return moment(control.value, 'DD-MM-YYYY', true).isValid() ? null : {validDate: true};
}
